// src/locales/en/shops.js
export const shops = {
  
    createNewShop: "புதிய கடையை உருவாக்கு",
    setupYourShop: "உங்கள் கடையின் விவரங்கள் மற்றும் கட்டமைப்பை அமைக்கவும்",
    backToShops: "கடைகளுக்கு திரும்பு",
    
    online: "ஆன்லைன் கடை",
    pos: "POS/உடல் கடை",
    dropshipper: "டிராப்ஷிப்பர்",
    
    basicInformation: "அடிப்படை தகவல்",
    basicInformationDesc: "உங்கள் கடை பற்றிய அடிப்படை விவரங்களை வழங்கவும்",
    shopName: "கடையின் பெயர்",
    shopNamePlaceholder: "உங்கள் கடையின் பெயரை உள்ளிடுங்கள்",
    printableName: "அச்சிடும் பெயர்",
    printableNamePlaceholder: "waybill-இல் அச்சிட வேண்டிய பெயர் (viruppam)",
    printableNameHint: "அமைக்கப்பட்டால், கடையின் பெயருக்குப் பதிலாக இந்தப் பெயர் waybill label-இல் அச்சிடப்படும்",
    shopType: "கடை வகை",
    orderPrefix: "ஆர்டர் எண் முன்னொட்டு",
    prefixHint: "இது ஆர்டர் எண்களை உருவாக்க பயன்படும் (எ.கா: ABC-001)",
    addressPlaceholder: "கடையின் முகவரியை உள்ளிடுங்கள்",
    phone: "தொலைபேசி எண்",
    phonePlaceholder: "தொடர்பு எண்ணை உள்ளிடுங்கள்",
    address: "முகவரி",
    
    shopLogo: "கடை லோகோ",
    logoDesc: "உங்கள் கடையின் லோகோவை பதிவேற்றவும் (விருப்பமான)",
    uploadLogo: "லோகோ பதிவேற்ற கிளிக் செய்யவும்",
    logoFormats: "PNG, JPG, WEBP 5MB வரை",
    
    deliveryCharges: "டெலிவரி கட்டணங்கள்",
    deliveryChargesDesc: "ஒவ்வொரு ஷிப்பிங் மண்டலத்திற்கும் டெலிவரி கட்டணங்களை அமைக்கவும்",
    deliveryChargesHint: "ஒவ்வொரு மண்டலத்திற்கும் போட்டி டெலிவரி கட்டணங்களை அமைக்கவும். இந்த விலைகள் வாடிக்கையாளர்களுக்கு செக்அவுட்டின் போது காட்டப்படும்.",
    
    serviceCharge: "சேவை கட்டணம்",
    serviceChargeDesc: "டிராப்ஷிப்பர் ஆர்டர்களுக்கான நிலையான சேவை கட்டணம்",
    serviceChargeAmount: "சேவை கட்டணம் (LKR)",
    serviceChargeHint: "ஒவ்வொரு ஆர்டருக்கும் நிலையான தொகை",
    
    nameRequired: "கடையின் பெயர் தேவை",
    typeRequired: "தயவுசெய்து ஒரு கடை வகையைத் தேர்ந்தெடுக்கவும்",
    prefixRequired: "ஆர்டர் முன்னொட்டு தேவை",
    prefixMinLength: "முன்னொட்டு குறைந்தது 2 எழுத்துகளாக இருக்க வேண்டும்",
    prefixTaken: "இந்த முன்னொட்டு ஏற்கனவே எடுக்கப்பட்டுள்ளது",
    prefixAvailable: "முன்னொட்டு கிடைக்கிறது",
    invalidPhone: "தயவுசெய்து சரியான தொலைபேசி எண்ணை உள்ளிடுங்கள்",
    deliveryChargesRequired: "தயவுசெய்து அனைத்து மண்டலங்களுக்கும் டெலிவரி கட்டணங்களை அமைக்கவும்",
    serviceChargeRequired: "டிராப்ஷிப்பர்களுக்கு சேவை கட்டணம் தேவை",
    invalidServiceCharge: "தயவுசெய்து சரியான சேவை கட்டணத்தை உள்ளிடுங்கள்",
    invalidLogoFormat: "லோகோ PNG, JPG, JPEG, அல்லது WEBP வடிவத்தில் இருக்க வேண்டும்",
    logoTooLarge: "லோகோ கோப்பு அளவு 5MB க்கும் குறைவாக இருக்க வேண்டும்",
    
    loadingData: "தரவு ஏற்றப்படுகிறது...",
    loadingDataDesc: "தேவையான தகவல்களைப் பெறும்போது தயவுசெய்து காத்திருங்கள்.",
    
    createShop: "கடையை உருவாக்கு",
    
    shopCreatedSuccess: "'{{shopName}}' கடை வெற்றிகரமாக உருவாக்கப்பட்டது!",
    failedToCreate: "கடையை உருவாக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    failedToLoadZones: "ஷிப்பிங் மண்டலங்களை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",

    manageYourShops: "உங்கள் அனைத்து கடைகள் மற்றும் அவற்றின் கட்டமைப்புகளை நிர்வகிக்கவும்",
    loadingShops: "கடைகள் ஏற்றப்படுகின்றன...",
    loadingShopsDesc: "உங்கள் கடைகளைப் பெறும்போது தயவுசெய்து காத்திருங்கள்.",
    searchShops: "பெயர், முன்னொட்டு, முகவரி அல்லது தொலைபேசி மூலம் கடைகளைத் தேடுங்கள்...",
    filteredResults: "{{total}} இல் {{count}} கடைகள்",
    totalShops: "{{count}} கடைகள்",
    allShops: "அனைத்து கடைகள்",
    noSearchResults: "கடைகள் கிடைக்கவில்லை",
    noSearchResultsDesc: "உங்கள் தேடல் சொற்களை சரிசெய்ய முயற்சிக்கவும் அல்லது அனைத்து கடைகளையும் பார்க்க வடிகட்டிகளை அழிக்கவும்.",
    noShops: "இன்னும் கடைகள் இல்லை",
    noShopsDesc: "உங்கள் வணிக செயல்பாடுகளை நிர்வகிக்கத் தொடங்க உங்கள் முதல் கடையை உருவாக்கவும்.",
    createFirstShop: "முதல் கடையை உருவாக்கு",

    editShop: "கடையை திருத்து",
    updateShop: "கடையை புதுப்பி",
    updateShopDetails: "உங்கள் கடையின் விவரங்கள் மற்றும் கட்டமைப்பை புதுப்பிக்கவும்",
    shopUpdatedSuccess: "'{{shopName}}' கடை வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
    failedToUpdate: "கடையை புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    unsavedChanges: "சேமிக்கப்படாத மாற்றங்கள்",
    confirmDiscardChanges: "உங்களிடம் சேமிக்கப்படாத மாற்றங்கள் உள்ளன. சேமிக்காமல் வெளியேற விரும்புகிறீர்களா?",
    discardChanges: "மாற்றங்களை நிராகரி",
    noChangesToSave: "சேமிக்க எந்த மாற்றங்களும் செய்யப்படவில்லை.",
    noChanges: "மாற்றங்கள் இல்லை",
    
    logo: "லோகோ",
    type: "வகை",
    prefix: "முன்னொட்டு",
    contact: "தொடர்பு",
    
    noContact: "தொடர்பு தகவல் இல்லை",
    
    confirmDelete: "'{{shopName}}' கடையை நீக்க விரும்புகிறீர்களா? இந்த செயலை மாற்ற முடியாது.",
    shopDeletedSuccess: "'{{shopName}}' கடை வெற்றிகரமாக நீக்கப்பட்டது.",
    failedToDelete: "கடையை நீக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",

    editUser: "பயனரைத் திருத்து",
    updateUser: "பயனரை புதுப்பி",
    updateTeamMember: "குழு உறுப்பினரின் விவரங்கள் மற்றும் அனுமதிகளை புதுப்பிக்கவும்",
    changePassword: "கடவுச்சொல்லை மாற்று",
    loadingUser: "பயனர் ஏற்றப்படுகிறது...",
    loadingUserDesc: "பயனர் தரவைப் பெறும்போது தயவுசெய்து காத்திருங்கள்.",
    userNotFound: "பயனர் கிடைக்கவில்லை. அது நீக்கப்பட்டிருக்கலாம்.",
    failedToLoadUser: "பயனர் தரவை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    noChangesToSave: "சேமிக்க எந்த மாற்றங்களும் செய்யப்படவில்லை.",
    userUpdatedSuccess: "பயனர் '{{userName}}' வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
    failedToUpdate: "பயனரை புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    confirmDiscardChanges: "உங்களிடம் சேமிக்கப்படாத மாற்றங்கள் உள்ளன. சேமிக்காமல் வெளியேற விரும்புகிறீர்களா?",
    discardChanges: "மாற்றங்களை நிராகரி",
    noChanges: "மாற்றங்கள் இல்லை",
    unsavedChanges: "சேமிக்கப்படாத மாற்றங்கள்",

    setupExtraCharges: "கூடுதல் எடைக்கு கூடுதல் கட்டணங்களை அமைக்கவும்",
    extraChargesDesc: "அடிப்படை டெலிவரிக்கு அப்பால் கூடுதல் கிலோகிராமுக்கு வாடிக்கையாளர்களிடம் கட்டணம் வசூலிக்கவும்",
    extraChargePerKg: "KG-க்கு கூடுதல் கட்டணம்",
    extraChargePerKgPlaceholder: "0.00",
    extraChargesRequired: "அனைத்து மண்டலங்களுக்கும் சரியான KG கட்டணங்களை உள்ளிடவும்",

    // Catalog Settings
    catalogSettings: "பொது பட்டியல்",
    catalogSettingsDesc: "வாடிக்கையாளர்கள் ஒரு பட்டியல் இணைப்பு வழியாக பொருட்களை பார்க்கவும் ஆர்டர் செய்யவும் அனுமதிக்கவும்",
    catalogEnabled: "பொது பட்டியலை இயக்கவும்",
    catalogEnabledHint: "இயக்கப்படும்போது, வாடிக்கையாளர்கள் உங்கள் பட்டியல் URL வழியாக பொருட்களை பார்த்து ஆர்டர் செய்யலாம்",
    catalogSlug: "பட்டியல் URL",
    catalogSlugPlaceholder: "எ.கா: my-shop",
    catalogSlugHint: "3–80 எழுத்துகள், சிறிய எழுத்துகள், எண்கள் மற்றும் '-' மட்டுமே",
    catalogSlugAvailable: "Slug கிடைக்கிறது",
    catalogSlugTaken: "இந்த slug ஏற்கனவே பயன்பாட்டில் உள்ளது",
    catalogSlugInvalid: "தவறான slug வடிவம்",
    catalogSlugRequired: "பட்டியலை இயக்க URL தேவை",
    generateSlug: "பெயரிலிருந்து உருவாக்கு",

    // Message Center Shift Settings
    messageCenterShiftSettings: "Message Center Shifts",
    messageCenterShiftSettingsDesc: "இந்த shop-இன் orders-க்கு message center shift ஒதுக்கலாமா என்பதைக் கட்டுப்படுத்தவும்",
    messageCenterShiftEligible: "இந்த shop-க்கு Message Center Shifts-ஐ இயக்கவும்",
    messageCenterShiftEligibleHint: "இயக்கப்பட்டால், இந்த shop-இன் orders-க்கு ஒரு message center shift-ஐ ஒதுக்கலாம்",
    catalogPreviewLink: "பட்டியலை முன்னோட்டமிடு",
    catalogUrlLabel: "உங்கள் பட்டியல் URL:",

    // POS Settings
    posSettings: "POS அமைப்புகள்",
    posSettingsDesc: "இந்த கடைக்கான POS நடத்தையை உள்ளமைக்கவும்",
    allowCreditSales: "கடன் விற்பனையை அனுமதிக்கவும்",
    allowCreditSalesHint: "முழு கட்டணமின்றி கடன் பரிவர்த்தனைகளை முடிக்க cashier-களை அனுமதிக்கவும்",
    cashierSessionRequired: "Cashier அமர்வு கட்டாயமாக்கு",
    cashierSessionRequiredHint: "POS terminal பயன்படுத்துவதற்கு முன் cashier-கள் ஒரு அமர்வை திறக்க வேண்டும்",

    // WooCommerce Webhook Integration
    woocommerceIntegration: "WooCommerce ஒருங்கிணைப்பு",
    woocommerceIntegrationDesc: "உங்கள் WooCommerce கடையில் orders வைக்கப்படும் போது அவற்றை தானாகவே Rettzy இல் உருவாக்கவும்",
    woocommerceWebhookEnabled: "WooCommerce Webhook-ஐ இயக்கு",
    woocommerceWebhookEnabledHint: "இயக்கப்பட்டால், WooCommerce புதிய orders மற்றும் கட்டண புதுப்பிப்புகளை நேரடியாக Rettzy-க்கு அனுப்பலாம்",
    woocommerceWebhookEnabledSuccess: "WooCommerce webhook இயக்கப்பட்டது",
    woocommerceWebhookDisabledSuccess: "WooCommerce webhook முடக்கப்பட்டது",
    woocommerceWebhookToggleFailed: "WooCommerce webhook நிலையை புதுப்பிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    woocommerceWebhookSecret: "Webhook ரகசியம்",
    woocommerceWebhookSecretHint: "WooCommerce-இல் உள்ள இரண்டு webhook topics-களிலும் Secret புலத்தில் இதை ஒட்டவும்",
    woocommerceOrderCreatedUrl: "Order Created Webhook URL",
    woocommerceOrderStatusUpdatedUrl: "Order Status Updated Webhook URL",
    woocommerceRegenerateSecret: "ரகசியத்தை மீண்டும் உருவாக்கு",
    woocommerceRegenerateSecretConfirmTitle: "Webhook ரகசியத்தை மீண்டும் உருவாக்கு",
    woocommerceRegenerateSecretConfirm: "இது தற்போதைய ரகசியத்தை செல்லாததாக்கும். WooCommerce-இல் உள்ள இரண்டு webhook topics-களிலும் Secret புலத்தை புதிய மதிப்புடன் புதுப்பிக்க வேண்டும்.",
    woocommerceRegenerateSecretSuccess: "Webhook ரகசியம் மீண்டும் உருவாக்கப்பட்டது. அதை WooCommerce-இல் புதுப்பிக்கவும்.",
    woocommerceRegenerateSecretFailed: "Webhook ரகசியத்தை மீண்டும் உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    woocommerceShowSecret: "ரகசியத்தைக் காட்டு",
    woocommerceHideSecret: "ரகசியத்தை மறை",
    woocommerceCopy: "நகலெடு",
    woocommerceCopied: "Clipboard-க்கு நகலெடுக்கப்பட்டது",
    woocommerceCopyFailed: "நகலெடுக்க முடியவில்லை. கைமுறையாக நகலெடுக்கவும்.",
    woocommerceLastReceivedAt: "கடைசியாக webhook பெறப்பட்டது: {{date}}",
    woocommerceNeverReceived: "இதுவரை webhook எதுவும் பெறப்படவில்லை",
    woocommerceSetupHint: "WooCommerce-இல், Settings → Advanced → Webhooks-க்குச் சென்று கீழே உள்ள ஒவ்வொரு URL-க்கும் ஒரு webhook உருவாக்கவும் (topics: Order created / Order updated), பொருந்தும் URL மற்றும் Secret-ஐ ஒட்டவும்.",
    woocommerceApiTitle: "WooCommerce REST API (கைமுறை ஆர்டர் ஒத்திசைவு)",
    woocommerceApiDesc: "தவறிய webhook காரணமாக வராத ஆர்டர்களை Rettzy பெற அனுமதிக்கிறது. WooCommerce → Settings → Advanced → REST API இல் Read-only API key ஒன்றை உருவாக்கவும்.",
    woocommerceStoreUrl: "கடை URL",
    woocommerceStoreUrlPlaceholder: "https://your-store.com",
    woocommerceConsumerKey: "Consumer Key",
    woocommerceConsumerSecret: "Consumer Secret",
    woocommerceKeySaved: "சேமிக்கப்பட்டது: {{key}}. தற்போதைய key-ஐ வைத்திருக்க காலியாக விடவும்.",
    woocommerceSecretSaved: "•••••••• சேமிக்கப்பட்டது — வைத்திருக்க காலியாக விடவும்",
    woocommerceSaveApi: "API credentials சேமிக்கவும்",
    woocommerceTestConnection: "இணைப்பைச் சோதிக்கவும்",
    woocommerceApiSaveSuccess: "WooCommerce API credentials சேமிக்கப்பட்டன",
    woocommerceApiSaveFailed: "WooCommerce API credentials சேமிக்க முடியவில்லை",
    woocommerceTestSuccess: "WooCommerce இணைப்பு வெற்றிகரமானது",
    woocommerceTestFailed: "WooCommerce உடன் இணைக்க முடியவில்லை",
    woocommerceSaveCredentialsFirst: "இணைப்பைச் சோதிக்கும் முன் API credentials சேமிக்கவும்",
    woocommerceSyncTitle: "WooCommerce ஆர்டர் ஒத்திசைவு",
    woocommerceSyncDesc: "தவறிய webhook காரணமாக வராத ஆர்டர்களை WooCommerce இலிருந்து நேரடியாகப் பெறுங்கள்.",
    woocommerceSyncSelectShop: "கடை",
    woocommerceSyncChooseShop: "கடையைத் தேர்ந்தெடுக்கவும்",
    woocommerceSyncNoShops: "WooCommerce webhook இயக்கப்பட்ட கடைகள் இல்லை. முதலில் Edit Shop இல் இயக்கவும்.",
    woocommerceSyncMissingCredentials: "இந்தக் கடைக்கு இன்னும் WooCommerce REST API keys இல்லை.",
    woocommerceSyncAddCredentials: "Edit Shop இல் API keys சேர்க்கவும்",
    woocommerceSyncLastSync: "கடைசி கைமுறை ஒத்திசைவு: {{date}}",
    woocommerceSyncNeverSynced: "இன்னும் கைமுறை ஒத்திசைவு இல்லை",
    woocommerceSyncByIdTitle: "ஒரு ஆர்டரை ஒத்திசைக்கவும்",
    woocommerceSyncByIdDesc: "WooCommerce ஆர்டர் ஐடியை உள்ளிடவும். ஆர்டர் Rettzy இல் உருவாக்கப்படும், ஏற்கனவே இருந்தால் புதுப்பிக்கப்படும்.",
    woocommerceSyncOrderIdLabel: "WooCommerce ஆர்டர் ஐடி",
    woocommerceSyncFetch: "பெற்று ஒத்திசை",
    woocommerceSyncByDateTitle: "தேதியின்படி ஆர்டர்களை ஒத்திசைக்கவும்",
    woocommerceSyncByDateDesc: "தேர்ந்தெடுத்த தேதியில் உருவாக்கப்பட்ட அனைத்து WooCommerce ஆர்டர்களையும் (அதிகபட்சம் 500) பெற்று Rettzy இல் உருவாக்கவும் அல்லது புதுப்பிக்கவும்.",
    woocommerceSyncDateLabel: "ஆர்டர் தேதி",
    woocommerceSyncOrders: "ஆர்டர்களை ஒத்திசை",
    woocommerceSyncing: "ஒத்திசைக்கிறது…",
    woocommerceSyncingHint: "இதற்கு ஒரு நிமிடம் ஆகலாம். இந்தப் பக்கத்தைத் திறந்தே வைக்கவும்.",
    woocommerceSyncConfirmTitle: "WooCommerce ஆர்டர்களை ஒத்திசைக்கவும்",
    woocommerceSyncConfirm: "{{shop}} இல் {{date}} அன்று உருவாக்கப்பட்ட அனைத்து WooCommerce ஆர்டர்களையும் பெற்று Rettzy இல் உருவாக்க அல்லது புதுப்பிக்கவா?",
    woocommerceSyncResults: "ஒத்திசைவு முடிவுகள்",
    woocommerceSyncTotal: "மொத்தம்",
    woocommerceSyncCreated: "உருவாக்கப்பட்டது",
    woocommerceSyncUpdated: "புதுப்பிக்கப்பட்டது",
    woocommerceSyncSkipped: "தவிர்க்கப்பட்டது",
    woocommerceSyncFailed: "தோல்வி",
    woocommerceSyncColWcId: "WooCommerce ஆர்டர்",
    woocommerceSyncColStatus: "முடிவு",
    woocommerceSyncColOrder: "Rettzy ஆர்டர்",
    woocommerceSyncColMessage: "விவரங்கள்",
    woocommerceSyncNoOrders: "அந்தத் தேதிக்கு WooCommerce ஆர்டர்கள் எதுவும் இல்லை.",
    woocommerceSyncCopyFailed: "தோல்வியடைந்த ஆர்டர் ஐடிகளை நகலெடுக்கவும்",
    woocommerceSyncError: "WooCommerce ஒத்திசைவு தோல்வியடைந்தது",
    woocommerceSyncInvalidOrderId: "சரியான WooCommerce ஆர்டர் ஐடியை உள்ளிடவும்",
    woocommerceSyncLoadFailed: "கடைகளை ஏற்ற முடியவில்லை",

    // Bundle products
    bundleConfigure: "Configure Bundle Pricing",
    bundleComponentsMissing: "These bundle products are not assigned to this shop: {products}",
    bundlePrice: "Bundle Price",
    unitValue: "Unit Value",
    lineDiscount: "Discount",
    bundleLoadFailed: "Failed to load bundle details",
}